import { useViewer } from '../store/context';
import type { ViewerState } from '../store/viewer-store';

type Mode = ViewerState['editMode'];

export function ModeToggle({ large }: { large: boolean }) {
  const editMode = useViewer((s) => s.editMode);
  const setEditMode = useViewer((s) => s.setEditMode);

  const modes: Mode[] = large ? ['view', 'edit', 'split'] : ['view', 'edit'];
  const label: Record<Mode, string> = { view: 'View', edit: 'Edit', split: 'Split' };
  // Split collapses to Edit on small screens; reflect that effective mode so the
  // visible buttons show the correct active state.
  const active: Mode = editMode === 'split' && !large ? 'edit' : editMode;

  return (
    <div
      className="flex items-center gap-0.5 rounded-md bg-neutral-200/60 p-0.5 dark:bg-neutral-800/60"
      role="group"
      aria-label="Editor mode"
    >
      {modes.map((m) => (
        <button
          key={m}
          type="button"
          onClick={() => {
            setEditMode(m);
          }}
          aria-pressed={active === m}
          className={`mr-btn !min-h-7 !px-2 !py-0.5 ${
            active === m ? 'bg-white shadow-sm dark:bg-neutral-700' : ''
          }`}
        >
          {label[m]}
        </button>
      ))}
    </div>
  );
}
